module.exports = __webpack_public_path__ + "img/3.88b2916a.png";